/** A second copy of the same name gets -2 before the extension. */
export const uniqueFilename = (name: string, used: Map<string, number>) => {
  const key = name.toLowerCase();
  const seen = used.get(key) ?? 0;
  used.set(key, seen + 1);
  if (seen === 0) return name;
  const dot = name.lastIndexOf('.');
  const hasExtension = dot > 0 && name.length - dot <= 6;
  const stem = hasExtension ? name.slice(0, dot) : name;
  const extension = hasExtension ? name.slice(dot) : '';
  return `${stem}-${seen + 1}${extension}`;
};
